import React from 'react'
import { FormInput, FormSelect } from '@myxplor/forms'
import moment from 'moment'
import Attachment from './attachment'
import { NewWindowIcon } from '../../../ui/gov-messages'

import './accs.css'

const options = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]

const addFile = (event, values, onChange) => {
  const file = event.target.files[0]

  if (file) {
    const reader = new FileReader()

    reader.onload = (readerEvent) => {
      const binaryString = btoa(readerEvent.target.result)
      const blob = {
        content: `${binaryString}`,
        type: 'ACC002',
        name: file.name,
        size: file.size,
        mime: file.type
      }

      onChange('evidence', [...values.evidence, blob])
    }

    reader.readAsBinaryString(file)
  }
}

const Evidence = (props) => {
  const { readOnly = false, values, onChange, isDetermination } = props
  const evidenceHeld = values.evidence_held
  const thirdPartyOptional = '3rd Party Evidence Not Available (Optional)'
  const thirdPartyRequired = '3rd Party Evidence Not Available'
  const weeksSinceStart = values.start_date != null ? moment().diff(moment(values.start_date), 'weeks') : 0
  
  return (
    <fieldset>
      <legend>3. Evidence {(!isDetermination && weeksSinceStart < 5) ? '(Optional)' : ''}</legend>
      While evidence and further details are optional, you will need to update
      the certificate with evidence before the certificate ends.
      <div id='evidenceHeader'>
        <div>
          <strong>Attach Evidence{(isDetermination && values.weeks_at_risk > 13) || (!isDetermination && weeksSinceStart > 4) ? ' (Required)' : ''}</strong>
          <br />
          Government file limit: 5.4mb. PDF, PNG, JPG, TIFF only.
        </div>
        <div>
          <input
            type='file'
            id='file'
            onChange={(event) => addFile(event, values, onChange)}
            accept='.jpg, .png, .pdf, tiff'
          />
          {readOnly ? null : (
            <label htmlFor='file'>
              Attach
              <NewWindowIcon />
            </label>
          )}
        </div>
      </div>
      <hr />
      {values.evidence && values.evidence.map((_, idx) => {
        return <Attachment key={idx} idx={idx} {...props} />
      })}
      <div id='evidenceHeld'>
        <FormSelect
          htmlSelect={{ disabled: readOnly }}
          label={'Evidence Held?'}
          name={'evidence_held'}
          value={values.evidence_held}
          onChange={onChange}
          options={options}
          compact
        />
      </div>
      {isDetermination && (
        <div>
          <FormInput
            label={evidenceHeld === 'false' ? thirdPartyRequired : thirdPartyOptional}
            name='reason_no_3rd_party'
            value={values.reason_no_3rd_party}
            type='text'
            maxLength={1000}
            required={evidenceHeld === 'false'}
            autoFocus={false}
            onChange={onChange}
            loading={false}
          />
          Explain why third party evidence is not available.
          <FormInput
            label={'Additional Information (Optional)'}
            name='evidence_additional_infor'
            value={values.evidence_additional_infor}
            type='text'
            maxLength={1000}
            autoFocus={false}
            onChange={onChange}
            loading={false}
          />
        </div>
      )}
    </fieldset>
  )
}

export default Evidence



// WEBPACK FOOTER //
// ./src/care-enrolments/accs/form/evidence.js